module.exports = __webpack_public_path__ + "img/calendar.9388fc67.png";